import axios from 'axios'
import { handleLocalStorage } from './handleLocalStorage'
import { formatGuid } from './formatGuid'

// Rescue path for installed PWAs / direct visits on a CUSTOM domain: the URL has
// no ?data=/?guid= and storage is empty (iOS standalone web apps get storage
// isolated from Safari), so the company is recovered from the hostname via the
// public qr-menu-service lookup. Uses raw axios on purpose — the shared instance
// would redirect to /network-error and report to Sentry, while a failure here
// must silently fall through to the /welcome screen (the pre-rescue behaviour).
export const resolveCompanyFromHostname = async (): Promise<string> => {
  try {
    const app =
      process.env.REACT_APP_IS_CLIC === '1' ? 'clickcollect' : 'qrmenu'
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/custom-domain/company`,
      { params: { domain: window.location.hostname, app } }
    )
    const guid = data?.data?.guid
    if (!guid) return ''
    const formatted = formatGuid(guid)
    handleLocalStorage({ guid: formatted })
    return formatted
  } catch {
    return ''
  }
}
